export default __webpack_public_path__ + "static/media/bar.256d1806.jpg";